export class StatusColour {
	public static readonly RED = new StatusColour('red', '#cc0018', ['text-white']);
	public static readonly YELLOW = new StatusColour('yellow', '#ffce00', []);
	public static readonly GREEN = new StatusColour('green', '#008b5c', ['text-white']);
	public static readonly GREY = new StatusColour('grey', '#b5b5b5', ['text-white']);

	public static readonly STATUS_SORT_ORDER = new Map<string, number>([[StatusColour.RED.colour, 0], [StatusColour.YELLOW.colour, 1], [StatusColour.GREEN.colour, 2]]);

	public static readonly get: { [key: string]: StatusColour } = {
		'red': StatusColour.RED,
		'yellow': StatusColour.YELLOW,
		'green': StatusColour.GREEN,
		'gray': StatusColour.GREY,
		'dismiss': StatusColour.GREY
	};

	constructor(public readonly colour: string, public readonly hex: string, public readonly reportTextClass: string[]) { }

	public toString(): string {
		return this.colour;
	}
}
